/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

export interface CollapsibleSectionSignature {
  // The arguments accepted by the component
  Args: {
    isDisabled?: boolean;
    cannotOpen?: boolean;
  };
  // Any blocks yielded by the component
  Blocks: {
    footer: [];
    content: [];
    headerRight: [];
    title: [];
  };
  // The element to which `...attributes` is applied in the component template
  // Element: null;
}

export default templateOnlyComponent<CollapsibleSectionSignature>();
